/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .media-list[_ngcontent-%COMP%]{height:340px;border-radius:4px;background-color:#eef3f9;overflow-y:overlay;padding:10px;position:relative}[_nghost-%COMP%]   .media-item[_ngcontent-%COMP%]{position:relative;width:25em;margin:4px}[_nghost-%COMP%]   .media-item[_ngcontent-%COMP%]:hover   .delete-btn[_ngcontent-%COMP%]{display:block}[_nghost-%COMP%]   .media-item[_ngcontent-%COMP%]   .delete-btn[_ngcontent-%COMP%]{display:none;position:absolute;top:.5em;right:.5em;z-index:5;width:1.3em;height:1.3em;cursor:pointer}"];
export { styles as styles };
